





























import { vxm } from '../../store.vuex';
import { Component, Vue, Prop } from 'vue-property-decorator';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 7000,
});

@Component({
  name: 'ConfirmPhoneNumber',
  components: {},
})
export default class ConfirmPhoneNumber extends Vue {
  $wlToastr: any;
  private displayMessage: string = '';

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public confirmPhoneNumber(hash) {
    vxm.users.confirmPhoneNumber(hash).then((res) => {
      console.log('res -- ' + res);
      if (res.meta.success) {
        this.displayMessage = res.meta.displayMessage;
        this.$wlToastr('success', this.$t(this.displayMessage));
        return true;
      } else {
        this.displayMessage = res.meta.displayMessage;
        this.$wlToastr('error', this.$t(this.displayMessage));
        return false;
      }
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  mounted() {
    const phoneValidationCode = this.$route.query.phoneValidationCode + '';
    console.log('code is:' + phoneValidationCode);
    this.confirmPhoneNumber(phoneValidationCode);
  }
}
